var products_prices;
$(document).ready(function(){
  if ($(window).width() < 798) {
    $( ".big-product-image" ).insertAfter( ".product-description-box" );
    $("#cartform").find("table").find(".image").hide();
    $(".span12.details").find("img").parent().css("text-align","center");
  }
  $(".accordion > a").click(function(e){
    e.preventDefault();
    $(".accordion .content").fadeToggle(200);
  });




});
jQuery(window).on('load', function(){

  
  if ($(window).width() < 630) {
    $('.flexslider').flexslider({
      slideshow: false,
      controlNav: false
    });
  }else {
    /*$('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 8000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});*/
  }
  
  $("select.loc_on_change").change(function(){
    if($(this).find(":selected").attr("value") == "#") return false;
    window.location = $(this).find(":selected").attr("value");
  });

  
});

jQuery(document).ready(function($){


  // force wide nav -->  
  
  // <-- end force wide nav

  $(".flyout").hide();

  $("#menu-button").on("click", function() {
    $(".mobile-wrapper").show();
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more, .account-links").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
    $(this).next(".more").find("i").toggleClass("fa-user fa-minus");
  });

  $("a.zoom").fancybox({
    padding: 0
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  });

  /*  $('li.dropdown').hover(function(){
      if (window.scrollY < 25){
        $(this).children('.dropdown').show();
      $(this).children('.dropdown').stop();
      $(this).children('.dropdown').animate({
        opacity: 1.0
      }, 200);
      } 
    }, function(){
      $(this).children('.dropdown').stop();
      $(this).children('.dropdown').animate({
        opacity: 0.0
      }, 400, function(){
        $(this).hide();
      });
    });*/



  $('li.dropdown').mouseover( function(){
    if (window.pageYOffset < 25){
      //$(this).children('.megamenu-dropdown').removeClass("hide");
      //$(this).children('.dropdown').attr("style", "display: flex;");
      // if (e.target === this) {
      $(this).children('.dropdown').show();
      $(this).children('.dropdown').stop();
      $(this).children('.dropdown').animate({
        opacity: 1.0
      }); 
      //  }

    }
  })
  .mouseout( function(){
    $(this).children('.megamenu-dropdown').addClass("hide");
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
      // $(this).addClass("hide");
    });

  });

  $( window ).scroll(function() {
    if (window.pageYOffset > 25){
      $('li.dropdown').children('.megamenu-dropdown').addClass("hide");
      $('li.dropdown').children('.dropdown').stop();
      $('li.dropdown').children('.dropdown').animate({
        opacity: 0.0
      }, 400, function(){
        //$(this).addClass("hide");
        $(this).hide();
      });
    }
  });



  $('.toolbar .country-selector a, .toolbar .country-selector i').click(function(e){
    e.preventDefault();
    $('.toolbar .country-selector a.hiddenf').toggle();
  });
  $('.toolbar .country-selector a.hiddenf').click(function(e){
    e.preventDefault();
    window.location.href = $(this).attr('data-link');
    $('.toolbar .country-selector a').hide();
    $(this).show();
  });
});

console.log("script loaded: scripts.js");